import { Box } from '@/shared/ui';
import { useTheme } from '@mui/material';
import { HintFieldSkeletron } from '../hint-field';

interface IProps {
    hintField?: string;
    hintToLeft?: boolean;
}

export const InsuranceListItemSkeleton = ({ hintToLeft, hintField }: IProps) => {
    const theme = useTheme();

    return (
        <Box bgWhite sx={{ width: 426, maxWidth: '100%', borderRadius: '6px', [theme.breakpoints.down('sm')]: { padding: '1.5625rem' } }}>
            <div className="border-b-1 border-[#434343] pb-[1.5rem] flex justify-between items-center gap-3" data-testid="insurance-skeleton">
                <div className="flex flex-col">
                    <h3 className="font-atkinsonHyperlegible font-bold text-[1.375rem] mb-[1.5rem]" data-testid="insurance-skeleton-title">Insurance</h3>
                    <HintFieldSkeletron testId="insurance-hint-id" arrowDirection="up" name="Member ID" value="1234567" isActive={hintField === 'cardHolderID'} />
                </div>
                <div className="flex flex-col">
                    <span className="w-[8.625rem] sm-max:w-[120px] h-[1.875rem] bg-mint-200 mb-[0.875rem]" />
                    <span className="w-[8.625rem] sm-max:w-[120px] h-4 bg-mint-200" />
                </div>
            </div>
            <div className="pt-[1.5rem] flex justify-between items-center gap-3">
                <div className="flex flex-col">
                    <span className="w-[11.875rem] sm-max:w-[120px] h-[1.3125rem] bg-mint-200 mb-[0.4375rem]" />
                    <span className="w-[11.875rem] sm-max:w-[120px] h-[1.3125rem] bg-mint-200 mb-[0.4375rem]" />
                    <span className="w-[11.875rem] sm-max:w-[120px] h-[1.3125rem] bg-mint-200" />
                </div>

                <div className="flex flex-col justify-start items-end">
                    <HintFieldSkeletron
                        arrowDirection={hintToLeft ? 'left' : 'right'}
                        className="text-[0.9375rem] mb-[0.625rem] w-full"
                        name="Rx BIN"
                        value="123456"
                        isActive={hintField === 'provider.bin'}
                        testId="insurance-hint-rx-bin"
                    />
                    <HintFieldSkeletron
                        arrowDirection={hintToLeft ? 'left' : 'right'}
                        className="text-[0.9375rem] mb-[0.625rem] w-full"
                        name="Rx PCN"
                        value="1234567789"
                        isActive={hintField === 'provider.pcn'}
                        testId="insurance-hint-rx-pcn"
                    />
                    <HintFieldSkeletron
                        arrowDirection={hintToLeft ? 'left' : 'right'}
                        className="text-[0.9375rem] w-full"
                        name="Rx Group"
                        value="123456"
                        isActive={hintField === 'groupID'}
                        testId="insurance-hint-rx-group"
                    />
                </div>
            </div>
        </Box>
    );
};
